import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { COLOR_MAP } from '../../../common/utils/theme'

const CorrelationLegend = ({ indicatorSpecificRegions, selectedOnlyShow }) => {
  const { grouping } = useSelector((state) => state.common)

  const legendItems = useMemo(() => {
    const isOnlyShowIncomeGroup =
      grouping?.HCL_WB_INCOME?.map((group) => group.id)?.includes(
        selectedOnlyShow
      ) || false

    return isOnlyShowIncomeGroup
      ? grouping?.HCL_WB_INCOME
      : indicatorSpecificRegions
  }, [grouping, selectedOnlyShow, indicatorSpecificRegions])

  return (
    <div className="legend tui__legend_wrapper">
      {legendItems.map((item) => (
        <div className="tui__legend_item" key={item.code || item.id}>
          <div
            className="legend-dot"
            style={{ background: COLOR_MAP[item.code || item.id] }}
          ></div>
          <div className="legend-inner-text">
            {item.description || item.name}
          </div>
        </div>
      ))}
    </div>
  )
}
export default React.memo(CorrelationLegend)
